import React, { useState, useEffect } from "react";
import Button from "sushiweb/Button";
import NoFooterModal from "../../../../Common/NoFooterModal";
import { BottomSectionModal } from "../../../../../constants/assets/containers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as UserActions from "../../../../../store/actions/User";
import * as OrderActions from "../../../../../store/actions/Orders";
import { isValNull } from "../../../../../utils";
import Input from "sushiweb/InputTypes/Input";
import PaginatedReactDropdown from "../../../../Common/PaginatedReactDropdown";

const ForceCompleteModal = ({
  order_id,
  trip_id,
  data = {},
  handleClose,
  setStatus,
  forceComplete,
  reason_codes,
}) => {
  const [reason, setReason] = useState("");
  const [comment, setComment] = useState("");

  const handleCommentChange = (e) => {
    setComment(e);
  };

  const handleReasonChange = (key, val) => {
    setReason(val);
  };


  function handleSubmit() {
    if (isValNull(order_id)) {
      setStatus({
        type: "error",
        message: "no order_id present. reload page",
      });
      return;
    }
    if (isValNull(trip_id)) {
      setStatus({
        type: "error",
        message:
          "no trip_id present. only assigned orders can be force completed",
      });
      return;
    }
    if (isValNull(reason)) {
      setStatus({
        type: "error",
        message:
          "reason should be selected",
      });
      return;
  }

    forceComplete(order_id, { trip_id: trip_id,  reason_code: String(reason), comment: String(comment) }).then((r) => {
      if (r === "success") {
        setStatus({
          type: "success",
          message: "succesfully force completed",
        });
        handleClose();
      }
    });
  }
  return (
    <div>
      <NoFooterModal
        header={true}
        heading="Force complete"
        handleClose={handleClose}
        id="ForceCompleteModal"
        modalButtons={
          <BottomSectionModal>
            <Button
              data-testid="confirm-btn"
              onClick={handleSubmit}
              className="sushi-btn"
              disabled={false}
            >
              Submit
            </Button>
          </BottomSectionModal>
        }
      >
        <PaginatedReactDropdown
            options={reason_codes}
            labelKey="label"
            valueKey="key"
            labelWidth="8%"
            value={reason}
            handleChange={handleReasonChange}
            keyToChange="reason"
            placeholder="Reason"
            showCross={false}
            id="reasonDropdown"
        />
        <Input
          value={comment}
          onChange = {handleCommentChange}
          data-testid="tagName"
          id="sushi-input"
          label="comment"
          key={"r"}
        />
      </NoFooterModal>
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    forceComplete: bindActionCreators(OrderActions.forceComplete, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(ForceCompleteModal);
